export const normalizeMimeType = (type?: string) => {
  const trimmedType = type?.trim();

  if (!trimmedType) {
    return null;
  }

  if (trimmedType.includes('/')) {
    return trimmedType.toLowerCase();
  }

  return `image/${trimmedType.toLowerCase()}`;
};
